@if (permissions.CanViewMoi) {
    <linked-moi-overview
        [moiType]="moiType"
        [parentGuid]="parentGuid"
        [canAdd]="permissions.CanCreateMoi"
        [canDelete]="permissions.CanDeleteMoi"
        #linkedControlMoisComponent
    >
    </linked-moi-overview>
}

<hr />

@if (!isLoading && permissions.CanViewBim) {
    <app-linkable
        typename="measures of improvement of Finding Reports"
        [displayValueProp]="displayValueProp"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="!permissions.CanLinkBim"
        (onOpenClicked)="openItem($event)"
        [allowOpenItem]="true"
        [hideActions]="hideActions"
        [hideFilter]="hideFilter"
        [allowAddNew]="allowAddNew"
        (linkedChange)="onLinkedItemsChanged($event)"
        #linkedImMoi
    >
    </app-linkable>
}
